import { useEffect, useState, useRef } from "react";
import "./testimonial-slider.css";
import userImage from "../../assets/images/profile/user.png";

const testimonials = [
    { name: "RoHiT JAisWAL", feedback: "I just used this website for selling my old phone, They given best price for my old phone and Doorpick up service also. I think this website is best for selling your old phones", image: userImage },
    { name: "parasaram vishnu", feedback: "Cellcash is nice for the customers for selling the old mobiles and get cash", image: userImage },
    { name: "HASSAN G", feedback: "Great service and they quote fair prices on any electronic. If you’re looking to sell an item then you should stop in cellcash.", image: userImage },

    { name: "Shujath Ali", feedback: "Given Best price for used mobile and fast service.", image: userImage },
    { name: "Saddam Siddiqui", feedback: "Best Service and affordable price", image: userImage },
    { name: "abdul waseem", feedback: "Quick service and transparent pricing. A reliable platform for selling old devices!", image: userImage },
];


const TestimonialSlider = () => {
    const [itemsPerSlide, setItemsPerSlide] = useState(3);
    const [isClient, setIsClient] = useState(false);
    const carouselRef = useRef(null);

    useEffect(() => {
        setIsClient(true);

        const updateItemsPerSlide = () => {
            if (window.innerWidth <= 854) {
                setItemsPerSlide(1); // Show 1 per slide on mobile
            } else {
                setItemsPerSlide(3); // Show 3 per slide on desktop
            }
        };

        updateItemsPerSlide(); // Call on mount
        window.addEventListener("resize", updateItemsPerSlide);

        return () => window.removeEventListener("resize", updateItemsPerSlide);
    }, []);

    if (!isClient) {
        return null;
    }

    let slides = [];
    const totalSlides = Math.ceil(testimonials.length / itemsPerSlide);

    for (let i = 0; i < totalSlides; i++) {
        slides.push(testimonials.slice(i * itemsPerSlide, (i + 1) * itemsPerSlide));
    }

    return (
        <div className="testimonial_sliderDiv">
            <div
                ref={carouselRef}
                id="testimonialCarousel"
                className="carousel slide"
                data-bs-ride="carousel"
                data-bs-interval="3000"
                data-bs-wrap="true"
            >
                <div className="carousel-inner">
                    {slides.map((slide, index) => (
                        <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                            <div className="row justify-content-center">
                                {slide.map((testimonial, idx) => (
                                    <div key={idx} className="col-12 col-lg-4 col-md-6 col-sm-12 text-center d-flex">
                                        <div className="testimonial-bg testimonial d-flex flex-column justify-content-center align-items-center p-4" style={{ minHeight: "250px" }}>
                                            <p className="testimonial-feedback">"{testimonial.feedback}"</p>
                                            <img src={testimonial.image} className="rounded-circle mb-3" width={100} height={100} alt={testimonial.name} />
                                            <h5 className="testimonial-name">{testimonial.name}</h5>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>


                {/* Show controls only if more than one slide exists */}
                {testimonials.length > itemsPerSlide && (
                    <>
                        <button className="carousel-control-prev" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default TestimonialSlider;
